export const phoneReg = /^(1[0-9])\d{9}$/;
// export const IDcardReg = /^(\d{6})(\d{4})(\d{2})(\d{2})(\d{3})([0-9]|X)$/;
export const IDcardReg = (id)=>{
    var format = /^(([1][1-5])|([2][1-3])|([3][1-7])|([4][1-6])|([5][0-4])|([6][1-5])|([7][1])|([8][1-2]))\d{4}(([1][9]\d{2})|([2]\d{3}))(([0][1-9])|([1][0-2]))(([0][1-9])|([1-2][0-9])|([3][0-1]))\d{3}[0-9xX]$/;
                //号码规则校验
                if(!format.test(id)){
                    // return {'status':0,'msg':'身份证号码不合规'};
                    return false;
                }
                //区位码校验
                //出生年月日校验   前正则限制起始年份为1900;
                var year = id.substr(6,4),//身份证年
                    month = id.substr(10,2),//身份证月
                    date = id.substr(12,2),//身份证日
                    time = Date.parse(month+'-'+date+'-'+year),//身份证日期时间戳date
                    now_time = Date.parse(new Date()),//当前时间戳
                    dates = (new Date(year,month,0)).getDate();//身份证当月天数
                if(time>now_time||date>dates){
                    // return {'status':0,'msg':'出生日期不合规'}
                    return false
                }
                //校验码判断
                var c = new Array(7,9,10,5,8,4,2,1,6,3,7,9,10,5,8,4,2);   //系数
                var b = new Array('1','0','X','9','8','7','6','5','4','3','2');  //校验码对照表
                var id_array = id.split("");
                var sum = 0;
                for(var k=0;k<17;k++){
                    sum+=parseInt(id_array[k])*parseInt(c[k]);
                }
                if(id_array[17].toUpperCase() != b[sum%11].toUpperCase()){
                    // return {'status':0,'msg':'身份证校验码不合规'}
                    return false;
                }
                // return {'status':1,'msg':'校验通过'}
                return true
}
export const nameReg = /^[\u4E00-\u9FA5\uf900-\ufa2d]+$/;
export const codeReg = /^\d{6}$/;
export const bankCardReg= /^([1-9]{1})(\d{14}|\d{18})$/; //银行卡校验
// let regFlag = reg.test(this.rideUserName)



export const  emailReg = /^[a-zA-Z0-9_-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/   // 邮箱

export const  combination = (rule = [],value)=>{
    // rule = [1(中文),2[英文],3[数字],4[符号],5[手机号],6[邮箱],7[身份证号]] 
    if(rule.length){
        const  number = '0-9'   //数字
        const  Chinese = '\\u4e00-\\u9fa5'   //中文
        const  English = 'a-zA-Z'  // 英文
        const  patrn = "`~!@#$%^&*()_\\-+=<>?:{}|,.\\/;\\\\[\\]·~！@#￥%……&*（）——\\-+={}|《》？：“”【】、；‘，。、'"  //符号 （键盘上可见的非字母和数字的符号）

        const rulesFn = [
            null,
            Chinese,
            English,
            number,
            patrn,
            phoneReg,
            emailReg,
            IDcardReg
        ]

        let ruleVariable = null; //最终的规则 （str,obj,funtion）
        try {
            rule.forEach(item =>{
           
                if(item == 5 || item == 6 || item == 7){ //手机号/邮箱/证件号 
                    //直接返回对应的正则  退出循环
                    ruleVariable = rulesFn[item] 
                    throw Error();
                }else{
                    if(rulesFn[item]){
                        //  其他 需要多个正则拼接组成新的正则
                        ruleVariable = ruleVariable + rulesFn[item]
                    }else{
                        throw Error();
                    }
                    
                }
            })
        } catch (e) {
        }
        
        if(typeof ruleVariable == 'function'){
            return ruleVariable(value)
        }else{
            let reg; 
            //  ruleVariabl是一个字符串时需要newRegExp
            typeof ruleVariable == 'object' ?  reg = ruleVariable  : reg = new RegExp("^[" + ruleVariable + "]+$"); 
            if(reg.test(value)){
                return true
            }else{
                return false
            }
        }

    }
}
export default {
    phoneReg,
    IDcardReg,
    nameReg,
    codeReg,
    bankCardReg,
    emailReg,
    combination
}